/** Покупки в окнах: цена в Stars, стартовый пакет (окно поражения), счёт открыт, пока обещание не завершится. */
import { Icon } from "./kit";
import { type OfferPlace, type Product, type StarterOffer } from "@newfungame/contracts";
import { actions } from "./actions";
import { appStore, useStore, vipActive } from "../../app";
import { useEffect, useState } from "preact/hooks";

export function Stars({ n }: { n: number }) {
  return (
    <span class="win-stars">
      <Icon name="star" size={20} /> {n}
    </span>
  );
}

/** Стартовый пакет: окно держит предложение, пока открыто; купил — пропадает. Stars есть только в Mini App. */
export function useStarter(place: OfferPlace): StarterOffer | null {
  const canPay = useStore(appStore, (s) => s.miniApp);
  const vip = useStore(appStore, vipActive);
  const [offer] = useState(() => (canPay ? (appStore.get().player?.starter ?? null) : null));
  useEffect(() => {
    if (offer) actions().starterShown(place);
  }, []);
  return vip ? null : offer;
}

/** Покупка из окна: счёт открыт, пока обещание не завершится. */
export function useBuy(place: OfferPlace) {
  const [busy, setBusy] = useState(false);
  return {
    busy,
    buy(product: Product) {
      setBusy(true);
      void Promise.resolve(actions().buy(product, place)).finally(() => setBusy(false));
    },
  };
}
